// @flow
import { connect } from "react-redux";
import HomePageView from "./view";
import NoUserView from "./no-user-view";
import PasswordView from "./password-view";
import UpdatePanel from "../update-panel";
import PageHeaderView from "../header-view";
import JournalsPageView from "../journals-page-view";
import MessagesPageView from "../messages-page-view";
import PhotosPageView from "../photos-page-view";
import BlogCardListView from "./blog-card-list";
import Map from "../map";
import { showDialog } from "../state/context/actions";

export default connect(
    state => ({
        userInfo: state.context.userInfo,
        blogs: state.blogs.all,
        NoUserView,
        PasswordView,
        BlogCardListView,
        PageHeaderView,
        JournalsPageView,
        MessagesPageView,
        PhotosPageView,
        UpdatePanel,
        Map
    }),
    dispatch => ({
        onShowFeedback: () => dispatch(showDialog("feedback"))
    })
)(HomePageView);



// WEBPACK FOOTER //
// ./src/home-page-view/index.js